import React, { useEffect, useState } from 'react';
import { biLogger } from '../../../../../bi';
import { appMarketAppSupportedGeoSHover } from '@wix/bi-logger-market/v2';
import { Divider, Popover, Text, TextButton } from '@wix/design-system';
import s from './other-countries.scss';

export const CountriesPopover = ({
  popoverTitle,
  popoverElementTitle,
  countries,
  popoverFooter1,
  popoverFooter2,
  contactMail,
  appId,
  onSupportClick,
}) => {
  const [shown, toogleTooltip] = useState(false);
  useEffect(() => {
    if (shown) {
      biLogger.report(appMarketAppSupportedGeoSHover({ app_id: appId }));
    }
  }, [shown]);

  return (
    <Popover
      showArrow
      animate
      placement="right"
      shown={shown}
      onMouseEnter={() => toogleTooltip(true)}
      onMouseLeave={() => toogleTooltip(false)}
      appendTo="parent"
    >
      <Popover.Element>
        <TextButton as="a">{popoverElementTitle}</TextButton>
      </Popover.Element>
      <Popover.Content>
        <div className={s.countryPopover}>
          <Text size="small" weight="bold" className={s.countryPopoverTitle}>
            {popoverTitle}
          </Text>
          <div
            className={s.countriesList}
            style={countries.length < 5 ? { flexDirection: 'column' } : {}}
          >
            {countries.map((country) => (
              <Text
                size="small"
                weight="thin"
                className={s.countryPopoverCountry}
                style={{ display: 'inline-flex' }}
              >
                <div style={{ display: 'flex' }}>
                  <span>- &nbsp;</span>
                  <span style={{ flex: '1' }}>{country}</span>
                </div>
              </Text>
            ))}
          </div>
          {contactMail && (
            <>
              <Divider />
              <div className={s.popoverFooter}>
                <Text size="tiny" secondary>
                  {popoverFooter1}
                </Text>
                <TextButton
                  as="a"
                  size="tiny"
                  onClick={() => {
                    onSupportClick();
                  }}
                >
                  {popoverFooter2}
                </TextButton>
              </div>
            </>
          )}
        </div>
      </Popover.Content>
    </Popover>
  );
};
